import { DynamicMenu } from "../DynamicMenu";
import {
    brugereMenuLink, dashboardMenuLink,
    dataadministrationMenuLink,
    evalueringsstatistikMenuLink,
    fileAdministrationMenuLink,
    forloebOverviewMenuLink, interneLinksMenu, kursusoversigtMenu,
    uddannelseslaegeOverviewMenuLink,
    vejledereMenuLink
} from "core/layout/shared/MenuLinkProps";
import MenuProps from "./menuProps";
import useScreenResolution from "core/hooks/useScreenResolution";
import config from "../../../../config/config";


export const AdminMenu = ({ showNotification, nyhederMenuLink }: MenuProps) => {
    const { isMobile } = useScreenResolution();
    const dashboardMenu = dashboardMenuLink();
    const showDashboard = config.showDashboard ?? false;

    const menuLinks = [
        forloebOverviewMenuLink,
        vejledereMenuLink,
        evalueringsstatistikMenuLink,
        brugereMenuLink,
        nyhederMenuLink,
        dataadministrationMenuLink,
        fileAdministrationMenuLink,
        kursusoversigtMenu,
        interneLinksMenu
    ];

    if(isMobile)
        menuLinks.unshift(uddannelseslaegeOverviewMenuLink);

    if (showDashboard)
        menuLinks.unshift(dashboardMenu);

    return (
        <DynamicMenu menuLinks={menuLinks} showNotifications={showNotification}/>
    );

}
